import Modal from './Modal';

interface MentionsLegalesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function MentionsLegalesModal({ isOpen, onClose }: MentionsLegalesModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Mentions légales"
      showFooterClose
    >
      <div className="p-6 space-y-6 text-gray-700 dark:text-warm-gray-300">
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 1 – Identification de l'Éditeur, du Gestionnaire et de l'Hébergeur
          </h3>

          <div className="space-y-4">
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-warm-gray-100 mb-2">Éditeur du site</h4>
              <p>Aurore RH</p>
              <p>Statut : Micro-entreprise</p>
              <p>
                Email :{' '}
                <a
                  href="mailto:contact@aurorerh.fr"
                  className="text-aurore-dark hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  contact@aurorerh.fr
                </a>
              </p>
              <p>Numéro SIRET : 947 493 490 00017</p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 dark:text-warm-gray-100 mb-2">Gestion du site</h4>
              <p>La gestion du site est assurée par Aurore RH.</p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 dark:text-warm-gray-100 mb-2">Nom de domaine</h4>
              <p>
                Le nom de domaine{' '}
                <a
                  href="https://aurorerh.fr"
                  className="text-aurore-dark hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  aurorerh.fr
                </a>{' '}
                est enregistré auprès de OVH
              </p>
              <p>Adresse : 2 rue Kellermann, 59100 Roubaix, France</p>
              <p>
                Contact :{' '}
                <a
                  href="mailto:support@ovh.com"
                  className="text-aurore-dark hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  support@ovh.com
                </a>{' '}
                | Tél. : +33 9 72 10 10 07
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 dark:text-warm-gray-100 mb-2">Hébergeur du site</h4>
              <p>Infomaniak Network SA</p>
              <p>Adresse : Rue Eugène-Marziano 25, 1227 Les Acacias (Genève), Suisse</p>
              <p>IDE (UID) : CHE-103.167.648</p>
              <p>
                Site :{' '}
                <a
                  href="https://www.infomaniak.com"
                  className="text-aurore-dark hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.infomaniak.com
                </a>
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 dark:text-warm-gray-100 mb-2">Maintenance technique</h4>
              <p>La maintenance technique du site est assurée par Wibeo</p>
              <p>
                Email :{' '}
                <a
                  href="mailto:contact@wibeo.fr"
                  className="text-aurore-dark hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  contact@wibeo.fr
                </a>
              </p>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 2 – Propriété intellectuelle
          </h3>
          <p>
            L'ensemble des contenus présents sur le site{' '}
            <a
              href="https://aurorerh.fr"
              className="text-aurore-dark hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              aurorerh.fr
            </a>{' '}
            (textes, images, logos, icônes, graphismes, documents) est la propriété exclusive
            d'Aurore RH, sauf mention contraire.
          </p>
          <p className="mt-2">
            Toute reproduction, diffusion ou modification, totale ou partielle, sans autorisation
            écrite préalable est interdite.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 3 – Protection des données personnelles
          </h3>
          <p>
            Le site{' '}
            <a
              href="https://aurorerh.fr"
              className="text-aurore-dark hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              aurorerh.fr
            </a>{' '}
            ne stocke aucune donnée personnelle directement sur le domaine aurorerh.fr.
          </p>
          <p className="mt-2">
            Les données saisies via les formulaires/sondages sont enregistrées et traitées via
            Tally, et les données liées à la prise de rendez-vous sont enregistrées et traitées via
            Cal.eu, Ces services tiers déclarent être conformes au RGPD.
          </p>
          <p className="mt-2">
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit
            d'accès, de rectification, d'opposition, de limitation et de suppression de vos données.
          </p>
          <p className="mt-2">
            Contact :{' '}
            <a
              href="mailto:contact@aurorerh.fr"
              className="text-aurore-dark hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              contact@aurorerh.fr
            </a>
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 4 – Cookies</h3>
          <p>
            Le site utilise des cookies afin d'améliorer l'expérience utilisateur et d'analyser le
            trafic. Vous pouvez configurer votre navigateur pour refuser ou limiter l'utilisation
            des cookies.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">Article 5 – Responsabilité</h3>
          <p>
            Aurore RH s'efforce d'assurer l'exactitude des informations publiées sur le site. Elle
            ne saurait être tenue responsable des erreurs, omissions ou dommages liés à
            l'utilisation du site.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-warm-gray-100 mb-4">
            Article 6 – Droit applicable et juridiction compétente
          </h3>
          <p>Les présentes mentions légales sont régies par le droit français.</p>
          <p className="mt-2">
            En cas de litige, les tribunaux français seront seuls compétents.
          </p>
        </section>
      </div>
    </Modal>
  );
}
